import WomanImg from '../assets/img/mainImg.png';

const Hero = () => {
  return (
    <section 
      id="home"
      className="flex flex-col lg:flex-row items-center bg-primary bg-cover bg-center bg-no-repeat py-8 sm:py-36 overflow-hidden mainimg"
    >
      {/* <div data-aos="flip-left" className="container mx-auto h-full"> */}
      <div  className="container mx-auto h-full">
        <div className="flex flex-col lg:flex-row items-center h-full">
          {/* Text Section */}
          <div className="flex-1 flex flex-col items-center lg:items-start mb-8 lg:mb-0 text-center lg:text-left">
            <p className="text-lg text-accent mb-[22px]">
              Hey, I'm Shakil! 👋
            </p>
            <h1 className="text-3xl leading-[44px] md:text-5xl md:leading-tight lg:text-5xl lg:leading-[1.2] font-bold md:tracking-[-2px] mb-6 softPulse">
            I build sleek web and mobile interfaces and skyrocket your sales with powerful email campaigns and On-page SEO that actually converts.
            </h1>
      <button className="btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all ">
              Work with me/chumkysk@gmail.com
            </button>
          </div>
          {/* Image Section */}
          <div className="flex-1 flex justify-center lg:justify-end items-center">
            <img
              className="w-[70%]  lg:w-auto max-w-sm lg:max-w-none rounded-xl"
              src={WomanImg}
              alt="Woman"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

